// Платное бронирование
const PAID = [
  55950777,
  50814942,
  45598284,
  41182425,
  40850079,
  50228700,
];

// Бронирование
const BOOKED = [
  39006300,
  33900082,
  37592316,
  55950773,
  50814939,
  35065584,
  29096401,
  21197641,
  42477951,
  40127310,
];

// Принимают решение
const TAKE_A_DECISION = [
  39006294,
  33900079,
  46323048,
  36829821,
  55950765,
  50814933,
  36204954,
  29096398,
  21189712,
  42477867,
  40127307,
  72630009,
  72629957,
  72629941,
  60779557,
  81339737,
  81043589,
  57272669,
  73139149,
  79916121,
  // Принимают решение: Горячий
  81043593,
  75681785,
  75680581,
  75678257,
  75677793,
  75676893,
  // Принимают решение: Тёплый
  81043597,
  79916129,
  75681789,
  75680585,
  75678261,
  75677797,
  75676781,
  // Принимают решение: Холодный
  81043601,
  79916133,
  75681793,
  75680589,
  75678265,
  75677801,
  75676785,
];

export const bookingStatuses = {
  PAID,
  BOOKED,
  TAKE_A_DECISION,
};

const bookedOrPaidStatusIds: ReadonlySet<number> = new Set([...BOOKED, ...PAID]);

export function isBookedOrPaidStatus (id: number | undefined): boolean {
  return id !== undefined && bookedOrPaidStatusIds.has(id);
}

/**
 * strana_lk-4219
 * Слаги для перехода к процессу бронирования
 */
export const BookingProcess = {
  free: 'free_booking_process', // Забронировать бесплатно
  paid: 'broker_booking_process', // Забронировать платно
  deal: 'deal_booking_process', // Со страницы сделки
} as const;

type BookingProcessKeys = keyof typeof BookingProcess;
export type BookingProcessProp = typeof BookingProcess[BookingProcessKeys];
